import { createIcon } from './factory'
import Icon from './hexagon.svg?react'

export const Hexagon = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
